import React from "react";
import { Link } from "react-router-dom";

const CarouselDesktop = ({ WorksDesc, setIsHovered }) => {
  return (
    <div className={"work_list_carousel"}>
      {WorksDesc.map((work) => (
        <div
          className="work "
          style={{ "--a": work.order }}
          onMouseEnter={() =>
            setIsHovered({
              description: work.description,
              title: work.title,
              icon: work.iconType.map((icon, index) => (
                <img
                  src={icon}
                  alt={`icon-${index}`}
                  key={`icon-${index}`}
                  className="img-icon"
                />
              )),

              images: work.image, //pour le background portfolio qui defile au hover
            })
          }
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* on obtient juste la 1ere image pour la couverture ainsi que le lien GitHub Pages    */}
          <Link to={work.lien} target={"_blank"}>
            <div className="containeImgCover">
              <img src={work.image[0]} alt={`work-${work.order}`} />
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
};

export default CarouselDesktop;
